import { Component, OnInit, ViewEncapsulation, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilityService, AuthenticationService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { CartService } from './../cart/cart.service';
import {
  ProductModel, CartModel, PriceModel, ResponseCartModel, RequestCartModel, RequestLineItemModel,
  LineItemModel, SkusModel, PriceInfoModel, PaymentDetailsModel, SEO
} from './../../models/';
import { UserProfileModel } from 'lib/ng2-sapmp/src/models';
import { TabModel, TabComponent } from 'lib/ng2-sapmp/src/ui-components/tab';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { SubscriptionCardModel } from 'lib/ng2-sapmp/src/ui-components/subscription-card';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { DetailService, SubscriptionRequestModel } from './shared';
import { TAB, BREADCRUMBS, PRODUCT_CONFIG, PREMIER_AUTHFAILURE_MESSAGE } from 'config';
import { FetchCriteriaModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { HeaderService } from './../header/header.service';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot/mobile-pivot.model';
import { DomSanitizer } from '@angular/platform-browser';
import { FormBuilderService } from 'lib/ng2-sapmp/src/ui-components/form-builder/form-builder.service';
import { MOBILEPIVOTS } from 'config';
import { CMSResolver } from 'lib/ng2-sapmp/src/providers/cms.resolver';

declare var logoutCurrentUser: any;
declare var ENV_PORTAL: any;
@Component({
  selector: 'app-details',
  providers: [DetailService, CartService, FormBuilderService],
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DetailsComponent implements OnInit, OnDestroy {

  id: string;
  productDetail: ProductModel;
  overview = 'active';
  pricing = 'deactive';
  alreadyOwnedProduct = false;
  overviewDisplay = 'display';
  pricingDisplay = 'nodisplay';
  productTabs: any;
  breadCrumbs: BreadCrumbModel[];
  tabDetails: Array<TabModel>;
  @ViewChild(TabComponent)
  tabComponent: TabComponent;
  pageLoader: boolean;
  skuTiles: Array<SkusModel>;
  termsConditionPopup: boolean;
  learnPopup = false;
  learnMessage: string;
  learnSubHeader: string;
  learnHeader: string;
  learnUrl: string;
  confirmModalPopup: ConfirmModalPopupModel;
  modalClass: string;
  subscriptionCardArray: Array<SubscriptionCardModel>;
  showTab: boolean;
  subscriptionData: any;
  subscribeFlag: boolean;
  user: UserProfileModel;
  permissionFlag: boolean;
  eventEmit: any;
  showButton: boolean;
  detailErrorMessage: string;
  formSuccess = false;
  submitting = false;
  initModal: string;
  modalContent: string;
  fetchCriteriaModel: FetchCriteriaModel;
  subscriptionRequestModel: SubscriptionRequestModel;
  subscribedSoc: string;
  banner_small: string;
  packageLabelName: string;
  pivots: Array<MobilePivotModel>;
  isFn: boolean = (ENV_PORTAL === 'fnabc') ? true : false;
  pageTitle: string;
  hasAmPermission: boolean;
  formSubmitSuccessMsg: string;
  authenticationRequired: boolean;
  //authenticated: boolean;
  permissions: any;
  NotFullPermit: boolean;
  fullPermit: boolean;
  emailAddress: any;
  phoneNumber: any;
  initialPhoneNumber: any;
  environmentPortal: any;
  contactName: any;
  fanNumber: any;
  efotaNotEnrollFans: any;
  userFanName: any;
  efotaNotEnrolledFans: any;
  currentEnrolledFan: any;
  unAuthSubscription: boolean;
  authSubscription: boolean;
  checkEFotaPage: any;
  subscriptionContent: any;
  errorMessage: any;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private _sanitizer: DomSanitizer,
    private changeDetectionRef: ChangeDetectorRef,
    private utilityService: UtilityService,
    private detailService: DetailService,
    private authenticationService: AuthenticationService,
    private cartService: CartService,
    private pageloaderService: PageLoaderService, private breadCrumbService: BreadCrumbService,
    private adobeAnalyticsService: AdobeAnalyticsService, private headerService: HeaderService
  ) {
    this.permissionFlag = false;
    this.pageloaderService.setPageLoaderStatus(false);
    this.skuTiles = [];
    this.learnPopup = false;
    this.subscriptionCardArray = [];
    this.showTab = false;
    this.showButton = true;
    this.termsConditionPopup = false;
    this.fetchCriteriaModel = new FetchCriteriaModel();
    this.subscriptionRequestModel = new SubscriptionRequestModel();
    this.subscriptionRequestModel.serviceOfferCodes = new Array<any>();
    this.packageLabelName = undefined;
    this.pivots = new Array<MobilePivotModel>();
  }


  ngOnInit() {
    const pageData = this.route.snapshot.data.pageData;
    this.headerService.setCondensedFooterStatus(false);
    this.headerService.condensedHeader('details');
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    const url = this.router.routerState.snapshot.url;
    const updatedUrl = url.substring(0, url.lastIndexOf('/'));
    document.title = this.utilityService.getPageTitleConfig()[updatedUrl];
    this.productDetail = new ProductModel();
    this.tabDetails = [];
    this.pageloaderService.setPageLoaderStatus(false);
    this.learnPopup = false;
    this.subscribeFlag = false;
    this.showButton = true;
    let perm = ['buy_and_manage', 'buy_only', 'manage_only'];
    if (sessionStorage.getItem('sapmp_jwtToken') !== null) {
      const userPermAm = this.authenticationService.getUser().permission;
      this.hasAmPermission = perm.indexOf(userPermAm) !== -1;
    }

    this.id = this.route.snapshot.params['id'];
    // this.detailService.getProductDetails(this.utilityService.getEnvConfig().catalogServiceUrl + this.id)
    //  this.detailService.getProductDetails(this.utilityService.getEnvConfig().cms + this.id)
    //   .subscribe(respObj => {

    const context = window.location.pathname.split('businessconsole')[1].replace(/\//g, '');
    let respObj = pageData[context];
    this.pageloaderService.setPageLoaderStatus(true);
    this.productDetail = respObj;
    this.fullPermit = ((this.isFullLoggedIn() && (this.productDetail.id === 'efota')) || this.productDetail.id !== 'efota');
    this.NotFullPermit = this.isNotFullLoggedIn() && this.productDetail.id === 'efota';
    this.efotaNotEnrollFans = !this.hasFans() && this.productDetail.id === 'efota';
    this.unAuthSubscription = !this.isLoggedIn() && this.productDetail.id === 'efota';
    this.authSubscription = this.isLoggedIn() && this.productDetail.id === 'efota';
    this.checkEFotaPage = this.checkEfotaPage();
    this.setSEO(this.productDetail.seo);
    this.productDetail.bannerName = (this.productDetail.bannerName)
      ? this.productDetail.bannerName : this.productDetail.displayName;
    this.packageLabelName = (this.productDetail.packageLabelName === undefined || this.productDetail.packageLabelName === '')
      ? this.productDetail.displayName + ' packages' : this.productDetail.packageLabelName;
    let childUrl = '/' + this.productDetail.site;
    this.breadCrumbService.setStaticBreadCrumbs(childUrl);
    this.breadCrumbService.setCurrentBreadCrumb({
      label: this.productDetail.displayName,
      routerLink: this.router.routerState.snapshot.url
    });
    this.pageTitle = (ENV_PORTAL === 'fnabc') ? 'FirstNet Apps & Solutions ' : 'Marketplace';
    const pivots = JSON.parse(JSON.stringify(MOBILEPIVOTS.PRODDUCTDETAILSPAGE));
    this.pivots = pivots;
    // this.banner_small = this.productDetail.media.largeImageUrl.replace('.png', '_small.png'); // TODO: need to change in services
    this.banner_small = this.productDetail.media.largeImageUrl.replace(/(\.[\w\d_-]+)$/i, '_small$1');

    this.skuTiles = (this.productDetail.skus) ? this.productDetail.skus.slice(0) : [];

    this.subscripitionSkutiles();

    /**
     *  Code to make tab dynamic
     */
    let rowIndex = 0;
    for (const tabElement of this.productDetail.template) {
      const tab = new TabModel();
      tab['key'] = tabElement.key;
      tab.id = tabElement.label;

      if (tabElement.key === 'subscription') {
        tab['subscription'] = JSON.parse(tabElement.additionalContent);
        tab['heading'] = this._sanitizer.bypassSecurityTrustHtml(tab['subscription'].heading);
        tab['subHeading'] = this._sanitizer.bypassSecurityTrustHtml(tab['subscription'].subHeading);
        tab['eligibleDevices'] = this._sanitizer.bypassSecurityTrustHtml(tab['subscription'].eligibleDevices);
      }
      else {
        tab['heading'] = this._sanitizer.bypassSecurityTrustHtml(tabElement.content);
        tab['subHeading'] = this._sanitizer.bypassSecurityTrustHtml(tabElement.content);
        tab['eligibleDevices'] = this._sanitizer.bypassSecurityTrustHtml(tabElement.content);
      }

      if (tabElement.key === 'form') {
        tab['formConfig'] = JSON.parse(tabElement.content);
        tab['description'] = this._sanitizer.bypassSecurityTrustHtml(tab['formConfig'].description);
        tab['permissionMessage'] = this._sanitizer.bypassSecurityTrustHtml(tab['formConfig'].permissionMessage);
        tab['noFansMessage'] = this._sanitizer.bypassSecurityTrustHtml(tab['formConfig'].noFansMessage);
        tab['blankMessage'] = this._sanitizer.bypassSecurityTrustHtml(tab['formConfig'].blankMessage);
        tab['requiredFields'] = this._sanitizer.bypassSecurityTrustHtml(tab['formConfig'].requiredFields);
        tab['totalDescription'] = this._sanitizer.bypassSecurityTrustHtml(tab['formConfig'].totalDescription);
        this.formSubmitSuccessMsg = tab['formConfig'].formSubmitSuccessMsg;
        this.errorMessage = tab['formConfig'].errorMessage;
        tab['formConfig'] = tab['formConfig'].form;
        if (this.isFullLoggedIn() && this.productDetail.id === 'efota' && !this.efotaNotEnrollFans) {
          // this.emailAddress = tab['formConfig'][7];
          // this.emailAddress.initialValue = JSON.parse(sessionStorage.getItem('user')).user.emailAddress;
          // this.phoneNumber = tab['formConfig'][6];
          // this.initialPhoneNumber = JSON.parse(sessionStorage.getItem('user')).user.contactPhoneNumber;
          // this.initialPhoneNumber = this.changeNumberFormatUS(this.initialPhoneNumber);
          // this.phoneNumber.initialValue = this.initialPhoneNumber;
          // this.contactName = tab['formConfig'][5];
          // this.contactName.initialValue = JSON.parse(sessionStorage.getItem('user')).user.firstName + " " + JSON.parse(sessionStorage.getItem('user')).user.lastName;
          // this.environmentPortal = tab['formConfig'][12];
          // if (sessionStorage.getItem('SAPMP_ENV_PORTAL') === "myatt") {
          //   this.environmentPortal.initialValue = "MyATT-ABC";
          // }
          // else if (sessionStorage.getItem('SAPMP_ENV_PORTAL') === "fnabc") {
          //   this.environmentPortal.initialValue = "FirstNet-ABC";
          // }
          // else {
          //   this.environmentPortal.initialValue = "Premier-ABC";
          // }
          // this.fanNumber = tab['formConfig'][0];
          // this.efotaNotEnrolledFans = JSON.parse(sessionStorage.getItem('efotaNotEnrolledFanList')).sort();
          // for (let i = 1; i <= this.efotaNotEnrolledFans.length; i++) {
          //   JSON.parse(sessionStorage.getItem('user')).user.fans.forEach(userFan => {
          //     if (userFan.fanId == this.efotaNotEnrolledFans[i - 1]) {
          //       this.userFanName = userFan.fanName;
          //     }
          //   })
          //   this.fanNumber.list.listValues[i] = { 'name': this.efotaNotEnrolledFans[i - 1], 'value': this.userFanName };
          // }
        }
        this.formSubmitSuccessMsg = (this.formSubmitSuccessMsg) ? this.formSubmitSuccessMsg : "You've successfully submitted your request. An AT&T representative will contact you.";
        this.errorMessage = (this.errorMessage) ?  this.errorMessage : "There is an issue with your submission. Please try submitting your request later.";
      } else {
        tab['description'] = this._sanitizer.bypassSecurityTrustHtml(tabElement.content);
        tab['permissionMessage'] = this._sanitizer.bypassSecurityTrustHtml(tabElement.content);
        tab['noFansMessage'] = this._sanitizer.bypassSecurityTrustHtml(tabElement.content);
        tab['blankMessage'] = this._sanitizer.bypassSecurityTrustHtml(tabElement.content);
        tab['requiredFields'] = this._sanitizer.bypassSecurityTrustHtml(tabElement.content);
        tab['totalDescription'] = this._sanitizer.bypassSecurityTrustHtml(tabElement.content);
      }

      tab.isActive = (rowIndex === 0) ? true : false;
      this.tabDetails.push(tab);
      rowIndex++;
    }
    this.showTab = true;


    /** Permissions */
    ({ 'modalRedirect': this.initModal } = this.route.snapshot.queryParams);
    if (this.initModal && this.initModal !== '') {
      this.permissionFlag = true;
    } else {
      this.permissionFlag = false;
    }
    this.changeDetectionRef.detectChanges();
    this.learnUrl = this.productDetail.productInfoUrl;
    this.detailService.createPageLoadProperties(this.skuTiles, this.router.routerState.snapshot.url, 'Details');
    this.pageloaderService.setPageLoaderStatus(true);
    // }, error => {
    //   this.pageloaderService.setPageLoaderStatus(true);
    //   this.handleError(error);
    // });

  }

  isFullLoggedIn() {
    return (sessionStorage.getItem('user') && (JSON.parse(sessionStorage.getItem('user')).user.addpAuthority == 'FULL')) ? true : false;
  }

  isNotFullLoggedIn() {
    return (sessionStorage.getItem('user') && (JSON.parse(sessionStorage.getItem('user')).user.addpAuthority != 'FULL')) ? true : false;
  }

  isLoggedIn() {
    return sessionStorage.getItem('user') ? true : false;
  }

  checkEfotaPage() {
    return this.productDetail.id === 'efota' ? true : false;
  }

  // changeNumberFormatUS(phone) {
  //   if (phone.length === 10) {
  //       return phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1.$2.$3");
  //   }
  //   return null;
  // }

  hasFans() {
    return (sessionStorage.getItem('efotaNotEnrolledFanList') && (JSON.parse(sessionStorage.getItem('efotaNotEnrolledFanList')).length > 0)) ? true : false;
  }

  setSEO(seo: SEO) {
    if (!seo) return;
    if (seo.title) document.title = seo.title;
    if (seo.description)
      document.getElementsByTagName('meta')['description'].content = seo.description;
  }

  pageNavigate() {
    if (this.authenticationService.getUser() !== null) {
      this.authenticationService.setLoginSuccessUrl('/productConfigurator/' + this.productDetail.id);
      // this.router.navigate(['login']);
      window.location.href = '/businessconsole/login';
    } else {
      this.router.navigate(['productConfigurator/' + this.productDetail.id]);
    }
  }

  handleSubscriptionEvent(skuId: string) {
    if (skuId === '/manage') {
      this.breadCrumbService.changeSessionSource('manageshop');
      this.router.navigate([skuId]);
    } else {
      for (const sku of this.skuTiles) {
        if (sku.id === skuId) {
          sku.selected = 1;
        } else {
          sku.selected = 0;
        }
      }
      this.skuTiles.sort((sku1, sku2): number => {
        return (sku2.selected - sku1.selected);
      });
      this.productDetail.skus = this.skuTiles;
      this.productDetail.quantity = 1;
      sessionStorage.setItem('productConfig-' + this.productDetail.id, JSON.stringify(this.productDetail));
      this.pageNavigate();
    }
  }

  updateTermsCondition(termsEvent) {
    this.termsConditionPopup = false;
  }

  showLearnDetails(event) {
    this.learnPopup = true;
    this.confirmModalPopup = new ConfirmModalPopupModel();
    this.confirmModalPopup.modalMessage = this.productDetail.learnMessage;
    this.confirmModalPopup.modalSubHeader = 'AT&T Business Console';
    this.confirmModalPopup.modalHeader = PRODUCT_CONFIG.learnHeader;
    this.confirmModalPopup.confirmButtonMessage = 'Yes';
    this.confirmModalPopup.cancelButtonMessage = 'No';
    this.confirmModalPopup.confirmButtonAccessibilityText = 'Yes.';
    this.eventEmit = event.target;
    this.modalClass = 'modal-lg';
  }

  updateLearnDetails(status) {
    this.learnPopup = false;
    if (status) {
      window.location.href = this.learnUrl;
    }
  }

  closeModal(event) {
    this.initModal = '';
  }

  private subscripitionSkutiles() {
    for (const sku of this.skuTiles) {
      sku.productId = this.productDetail.id;
      sku.priceInfo = new PriceInfoModel();
      const subscripitioncard = new SubscriptionCardModel();
      subscripitioncard.basicPrice = sku.basicPrice;
      subscripitioncard.description = sku.description;
      subscripitioncard.moduleCount = sku.moduleCount;
      subscripitioncard.skuType = sku.skuType;
      subscripitioncard.id = sku.id;
      subscripitioncard.detailFlag = 'SHOPNOW';
      subscripitioncard.productName = sku.displayName;
      subscripitioncard.isSingleQuantity = sku.isSingleQuantity;
      if (this.subscribeFlag === true) {
        if (sku.socCode === this.subscribedSoc) {
          this.alreadyOwnedProduct = true;
          subscripitioncard.detailFlag = 'ADDLICENSE';
        } else {
          subscripitioncard.detailFlag = '';
        }
      }
      this.subscriptionCardArray.push(subscripitioncard);
    }
    this.skuTiles.sort((sku1, sku2): number => {
      return (parseInt(sku1.basicPrice, 10) - parseInt(sku2.basicPrice, 10));
    });
  }

  pageLoadEvent(boolValue: boolean) {
    this.pageloaderService.setPageLoaderStatus(boolValue);
  }
  ngOnDestroy() {
    this.pageloaderService.setPageLoaderStatus(true);
  }

  handleError = (error) => {
    this.submitting = false;
    if (error) {
      this.detailErrorMessage = this.errorMessage;
      this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
      this.utilityService.loadFocusOnTop();
    } else {
      throw error;
    }
  }

  getFormConfigDetails(formOutputValue, tab) {
    tab['formValid'] = formOutputValue.valid;
    tab['form'] = formOutputValue.value;
    if (tab['formValid']) {
      console.log(tab['formValid']);
    }
  }

  translateData(tab) {
    for (const itrFormConfig of tab['formConfig']) {
      for (const itrFieldConfig of itrFormConfig.fields) {
        if (itrFieldConfig.elementType === 'checkbox' && itrFieldConfig.translate !== undefined && itrFieldConfig.translate === 'true') {
          tab['form'][itrFieldConfig.formControlName] = (tab['form'][itrFieldConfig.formControlName] === true || tab['form'][itrFieldConfig.formControlName] === "yes") ? "yes" : "no";
        }
      }
    }
  }

  submit(tab) {
    this.translateData(tab);
    console.dir(tab['form']);
    console.log(tab['formValid']);
    this.detailErrorMessage = null;
    this.formSuccess = false;
    this.submitting = true;
    window.scroll(0, 0);
    if (this.productDetail.id === 'efota') {
      this.currentEnrolledFan = tab['form'].foundationAccountNumber.name;
    }


    this.detailService.postForm(tab['form']).then(captchaResponse => {

      captchaResponse.subscribe(response => {
        console.dir(response);

        if (response.statusCode === '200') {
          // if (this.productDetail.id === 'efota') {
          //   let notEnrolledFanList = JSON.parse(sessionStorage.getItem('efotaNotEnrolledFanList'));
          //   for (let i = 0; i <= notEnrolledFanList.length; i++) {
          //     if (notEnrolledFanList[i] == this.currentEnrolledFan) {
          //       delete notEnrolledFanList[i];
          //       let newNotEnrolledFanList = notEnrolledFanList.filter(item => {
          //         return item != null;
          //       });
          //       sessionStorage.setItem("efotaNotEnrolledFanList", JSON.stringify(newNotEnrolledFanList));
          //     }
          //   }
          // }

          this.ngOnInit();
          this.formSuccess = true;
          this.submitting = false;
        } else {
          this.handleError(response);
        }
      }, error => {
        this.handleError(error);
      });
    });
  }



}